import {
	BENCH_FRAME_THICKNESS_MM,
	benchJoistLengthMm,
	benchRailLengthMm,
} from "./constants";

/** Svenskt Trä's removable bench detail leaves 20 mm across the room width.
 * The run still reserves the full wall-to-wall assembly, including fixed cleats. */
export const BENCH_REMOVAL_GAP_MM = 10;

/** Actual timber lengths. End-supported long rails bear directly on the cleats;
 * their end rails fit BETWEEN them instead of suspending the span from butt joints. */
export function benchFrameDimensions(
	lengthMm: number,
	depthMm: number,
	endSupported: boolean,
) {
	const endGapMm = endSupported ? BENCH_REMOVAL_GAP_MM : 0;
	const seatLengthMm = lengthMm - 2 * endGapMm;
	return {
		endGapMm,
		seatLengthMm,
		railLengthMm: endSupported ? seatLengthMm : benchRailLengthMm(lengthMm),
		endRailLengthMm: endSupported ? benchJoistLengthMm(depthMm) : depthMm,
		joistLengthMm: benchJoistLengthMm(depthMm),
		bearingLengthMm: endSupported ? BENCH_FRAME_THICKNESS_MM - endGapMm : 0,
	};
}
